import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../Assets/nav-logo.png';

const DataPageHeader = ({ title, description, account, onLogin, onLogout }) => {
  const location = useLocation();
  const navItems = [
    { to: '/customerData', label: 'Personal Tax' },
    { to: '/corporateData', label: 'Corporate Tax' },
  ];

  return (
    <header className="data-page-header mb-4">
      <div className="d-flex justify-content-between align-items-start w-100 gap-3 mb-3">
        <Link to="/" className="d-inline-flex">
          <img src={Logo} alt="OBS_logo" className="align-text-top" style={{ width: '280px', height: '85px' }} />
        </Link>
        <div className="d-flex flex-column flex-sm-row align-items-sm-center gap-2">
          {account ? (
            <>
              <button className="btn btn-outline-secondary" onClick={onLogout}>
                Logout
              </button>
            </>
          ) : (
            <button className="btn btn-primary" onClick={onLogin}>
              Sign in with Microsoft
            </button>
          )}
        </div>
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
        <div>
          <h1 className="mb-1">{title}</h1>
          <p className="text-muted mb-2">{description}</p>
          {account && (
            <div className="text-muted mb-2">
              Logged in as <strong>{account.username || account.name || 'User'}</strong>
            </div>
          )}
        </div>
        <div className="btn-group d-flex flex-wrap" role="group" aria-label="Page navigation">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`btn btn-sm ${location.pathname === item.to ? 'btn-primary' : 'btn-outline-primary'} flex-fill`}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </header>
  );
};

export default DataPageHeader;
